import wx from 'weixin-js-sdk'
export default {
  install (Vue, options) {
    Vue.prototype.banwxShare = function () {
      const url = location.href.split('#')[0]
      this.$post('callfee/share', {
        url
      }).then(res => {
        wx.config({
          debug: false,
          appId: res.appId,
          timestamp: res.timestamp,
          nonceStr: res.nonceStr,
          signature: res.signature,
          jsApiList: ['hideAllNonBaseMenuItem']
        })
        wx.ready(function () {
          wx.hideAllNonBaseMenuItem()
        })
      })
    }
  }
}



// WEBPACK FOOTER //
// ./src/libs/wechat.js